export const female_faces = [ //An array of each Female Face's ID, and Name. They use Atlas01. There are 10.
  {
    id: 'face5',
    name: 'Happy' //Show name in textbox.
  },
  {
    id: 'face3',
    name: 'Childish'
  },
  {
    id: 'face7',
    name: 'Smiling'
  },
  {
    id: 'face8',
    name: 'Tired'
  },
  {
    id: 'face2',
    name: 'Scared'
  },
  {
    id: 'face10',
    name: 'Panicked' //Pregnant Female scared face.
  },
  {
    id: 'face6',
    name: 'Sad'
  },
  {
    id: 'face4',
    name: 'Devilish'
  },
  {
    id: 'face1', 
    name: 'Dead',
    disable: 'child' //No Dead face.
  },
  {
    id: 'face9',
    name: 'Ghoulish'
  }
]